import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { GetApiTokensResponse } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useGetApiTokens = (): UseQueryResult<
  GetApiTokensResponse.AsObject,
  TGRPCPromiseReject
> => {
  const getApiTokens = useGetRequest(REQUEST_TYPES.API_TOKENS);

  return useQuery<GetApiTokensResponse.AsObject, TGRPCPromiseReject>({
    queryKey: ['apiTokens'],
    queryFn: () => getApiTokens({})
  });
};

export default useGetApiTokens;
